import { Box, Container, Typography, Link as MuiLink, Divider } from '@mui/material';
import diploLogo from '@/assets/diplo-logo.png';
import gipLogo from '@/assets/gip-logo.png';

interface FooterProps {
  showAbout?: boolean;
}

export default function Footer({ showAbout = false }: FooterProps) {
  return (
    <Box
      component="footer"
      sx={{
        pt: 2,
        pb: 4,
        px: 2,
        mt: 'auto',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0',
      }}
    >
      <Container maxWidth="lg">
        {showAbout && (
          <>
            <Box sx={{ mb: 2.5 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: '#1f1f1f', mb: 0.75, fontSize: '1rem' }}
              >
                About us
              </Typography>
              <Typography variant="body2" sx={{ color: '#3c4043' }}>
              Developed by DiploFoundation, this platform builds on research into digital diplomacy, information ecosystems, and global policy trends.
              </Typography>
            </Box>
            <Divider sx={{ mb: 2.5 }} />
          </>
        )}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} DiploFoundation. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
            <MuiLink
              href="https://www.diplomacy.edu/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="DiploFoundation"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                opacity: 0.85,
                transition: 'opacity 140ms ease',
                '&:hover': { opacity: 1 },
              }}
            >
              <Box
                component="img"
                src={diploLogo}
                alt="Diplo"
                sx={{ height: 36, width: 'auto', display: 'block' }}
              />
            </MuiLink>
            <MuiLink
              href="https://www.giplatform.org/genevas-digital-footprint/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Geneva Internet Platform"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                opacity: 0.85,
                transition: 'opacity 140ms ease',
                '&:hover': { opacity: 1 },
              }}
            >
              <Box
                component="img"
                src={gipLogo}
                alt="GIP"
                sx={{ height: 28, width: 'auto', display: 'block' }}
              />
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
